import { useState, type ChangeEvent } from "react";
import DemandesList from "../../components/Demandes/DemandesListComponent";
import { statusList, type DemandeParameters } from "../../types/Demande";
import { uniqid } from "../../tools/utils";
import { useAuth } from "../../contexts/auth/useAuth";
import { NavLink, useLocation } from "react-router";
import { roles } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";


function Demandes() {
    const location=useLocation();
    const search=new URLSearchParams(location.search);

    let statusFilter=search.getAll('statut');
    if (statusFilter.length == 0){
        statusFilter=['_','en_cours'];
    }
    const [params,setParams]=useState<DemandeParameters>({
            'r':{'statut':statusFilter},
            page:0, 
            order:'', 
            reverse:0
        });
    const {hasRole}=useAuth();
    const {translate}=useTrads();

    const onChange=function(e:ChangeEvent<HTMLInputElement>){
        const z:string[]=params.r.statut ? [...params.r.statut]:[];
        if(e.target.checked){
            if(!z.includes(e.target.value)){
                z.push(e.target.value);

            }
        }else{
            const index=z.indexOf(e.target.value);
            if(index>=0){
                z.splice(index, 1);

            }
        }
        setParams(
            {...params,
                   r:{...params.r,statut:z}
            }
        );

    }
    

    return (
        <div>
            <NavLink to="/demande/add" className="btn btn-primary mt-3">{translate('btn_add_demande')}</NavLink>
            <div className="d-flex flex-wrap mr-3">
                {statusList.map((item)=>{
                    const id=uniqid();
                    return (
                    <div  className="form-check form-switch"  key={id}>
                        <input id={id} className="form-check-input"  type="checkbox" value={item} onChange={onChange} checked={params.r.statut?.includes(item)} /> 
                        <label htmlFor={id} className="form-check-label">  {translate(item)}  </label>
                  
                    </div>
                )}
            )}
            </div>
            <DemandesList params={params} setParams={setParams} show_user={hasRole(roles.Operators)}   />  
        </div>
    );
}
export default Demandes;